import { TDictionary } from './types';

export const buildPathWithParams = (path: string, params: TDictionary<string>): string => {
  let finalPath = path;
  Object.keys(params).forEach((key) => {
    finalPath = finalPath.replace(`:${key}`, params[key]);
  });

  return finalPath;
};

export const parseQueryData = <T>(encoded: string | null): T | null => {
  if (!encoded) return null;

  try {
    const jsonStr = decodeBase64(encoded);
    const parsed = JSON.parse(jsonStr) as T;
    return parsed;
  } catch (err) {
    console.warn('Invalid base64 or JSON in query param:', err);
    return null;
  }
};

const decodeBase64 = (str: string): string => {
  try {
    const normalized = str.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return decodeURIComponent(
      Array.from(atob(padded))
        .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );
  } catch (err) {
    throw new Error('Invalid base64 string');
  }
};

export const validateUrlFormat = (url: string): URL => {
  const formattedUrl = url.match(/^https?:\/\//i) ? url : 'http://' + url;
  return new URL(formattedUrl);
};
